import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AppRoutingModule} from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatMenuModule} from '@angular/material/menu';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MsalModule, MsalService, MSAL_INSTANCE } from '@azure/msal-angular'
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import {HubComponent} from "./hub/hub.component";
import {MsalGuard} from "./Middleware/msal-guard.service";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import {MatButtonModule} from "@angular/material/button";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatNativeDateModule} from '@angular/material/core';
import {MatToolbarModule} from "@angular/material/toolbar";
import {NgxSpinnerModule} from "ngx-spinner";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { environment } from '../environments/environment';
import { HojasCallCenterModule } from './hojas-call-center/hojas-call-center.module';
import {MatIconModule} from "@angular/material/icon";
import { ExternoComponent } from './externo/externo.component';
import {TokenValidatorService} from "./Middleware/token-validator.service";
import { HibridValidatorService } from './Middleware/hibrid-validator.service';
import {PeticionesModule} from "./peticiones/peticiones.module";
import {HubExternoComponent} from "./hub-externo/hub-externo.component";
import {ModulosFunctions} from "./Middleware/ModulosFunction";

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: 'c8db4e2e-ead3-4e79-b63e-f438251871af',
      redirectUri: environment.msalRedirectUri,
    },
    cache: {
      cacheLocation: "localStorage" //Para que se mantenga la sesion en multiples tabs
    }
  })
}


@NgModule({
  declarations: [
    AppComponent,
    HubComponent,
    HubExternoComponent,
    ExternoComponent,
  ],
  imports: [
    BrowserModule,
    MsalModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatButtonModule,
    MatIconModule,
    MatGridListModule,
    MatFormFieldModule,
    MatToolbarModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    MatProgressSpinnerModule,
    HojasCallCenterModule,
    PeticionesModule,
  ],
  providers: [
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
      MsalService,
      MsalGuard,
      TokenValidatorService,
      HibridValidatorService,
      ModulosFunctions,
      MatNativeDateModule,

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

